import FileManagerContainer from "../../components/applications/fileManager";

const FileManager = () => {
  return <FileManagerContainer />;
};

export default FileManager;
